import React from 'react';
import PropTypes from 'prop-types';

export default class DocumentSchemas extends React.Component {

    render() {
        const { contractors } = this.props;
        const hasValues = contractors && contractors.every(con => !!con.contractor && !!con.document_schema);

        return (
            <React.Fragment>
                {
                    hasValues
                        ? this.renderDocumentSchemas()
                        : this.renderDocumentSchemasBackwardCompatibility()
                }
            </React.Fragment>
        );
    }

    renderDocumentSchemas = () => {
        const { contractors, currentUser, isOutsource } = this.props;
        const currentUserContractorId = currentUser._user.contractor.id;
        const documentSchemas = [];

        contractors.forEach(contractor => {
            const contractorId = contractor.contractor.id;
            const documentSchema = contractor.document_schema;
            if ( isOutsource ) {
                if ( contractorId === currentUserContractorId ) {
                    documentSchemas.push(documentSchema);
                }
            } else {
                if ( contractorId !== currentUserContractorId ) {
                    documentSchemas.push(documentSchema);
                }
            }
        });

        return (
            <div
                style={{
                    display: 'flex',
                    flexFlow: 'column nowrap',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                }}
            >
                {
                    documentSchemas.map(documentSchema => (
                            <div>{documentSchema.name}</div>
                        ),
                    )
                }
            </div>
        );
    };

    // Render para tener retrocompatibilidad con las entidades que no tienen los esquemas en contractors todavía
    renderDocumentSchemasBackwardCompatibility = () => {
        const { documentSchema } = this.props;
        return documentSchema ? documentSchema.name : '';
    };

}

DocumentSchemas.propTypes = {
    documentSchema: PropTypes.object,
    contractors: PropTypes.array,
    isOutsource: PropTypes.bool.isRequired,
    currentUser: PropTypes.any.isRequired,
};




// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentSchemas.jsx